<div class="flex-column">
	<tvcore-header (logout)="logout()" [brand]="'BRAND_NAME' | translate" [logoAlt]="'LOGO_ALT' | translate" [logo]="'LOGO' | translate" [user]="user$ | async"></tvcore-header>

	<div class="u-container content-with-header flex--1">
		<router-outlet></router-outlet>
	</div>

	<tvcore-footer [logoAlt]="'LOGO_ALT' | translate" [logo]="'LOGO' | translate">
		<ng-template #boldText>{{ 'FOOTER.BOLD' | translate }}</ng-template>
		<p>{{ 'FOOTER.NORMAL' | translate }}</p>
		<div class="c-footer__links u-m-top--xs">
			<a href="https://www.iedereenverdientvakantie.be/nl/privacy" target="_blank">Privacyverklaring</a>
			<span class="u-m-left--xxs u-m-right--xxs">|</span>
			<a href="https://www.iedereenverdientvakantie.be/nl/cookieverklaring-en-instellingen" target="_blank">Cookieverklaring</a>
		</div>
	</tvcore-footer>
</div>

@if (toasts(); as toasts) {
	<div class="c-toast-container">
		@for (toast of toasts; track toast.id) {
			<ivva-toast [toast]="toast"></ivva-toast>
		}
	</div>
}

<tvsk-session-keeper (logout)="logout()"></tvsk-session-keeper>
